module.exports = __webpack_public_path__ + "static/media/flyer.54f80761.png";